<template>
  <v-app>
    <v-app-bar
      clipped-left
      app
      dense
    >
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <v-img src="./assets/logo.png" />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span>DAYCARE PLANNING</span>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list dense>
        <v-list-item to="/home">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/token">
          <v-list-item-action>
            <v-icon>mdi-key</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Token</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/planning">
          <v-list-item-action>
            <v-icon>mdi-chart-gantt</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Planning</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <router-view />
    </v-content>
    <v-footer app>
      <v-spacer></v-spacer>
      &copy; {{ new Date().getFullYear() }}

    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'Application',
  data: () => ({
    drawer: true
    //
  }),
};
</script>
<style>
html {
  overflow-y: auto;
}
</style>